/** @jsxImportSource @emotion/react */

import { css } from "@emotion/core";
import zitelLogo from "../../assets/images/zitel-logo.svg";
import { useHistory } from "react-router-dom";
import Grid from "ui-modules/components/Layout/Grid";
import GridCell from "ui-modules/components/Layout/Grid/GridCell";
import Paper from "../../components/Paper";
import Text from "ui-modules/components/DataDisplay/Text";
import Img from "ui-modules/components/Image/Img";
import Button from "ui-modules/components/Form/Button";
import Image from "../../assets/images/Payment-yes-02.svg";

const SucceedPayment = () => {
  const history = useHistory();
  const queryParameters = new URLSearchParams(window.location.search);
  const trackNumber = queryParameters.get("trackNumber");
  const bssReceiptNumber = queryParameters.get("bssReceiptNumber");

  const styles = css`
    .success-container {
      color: inherit;
      text-align: center;
      min-height: 95vh;
    }
    Img {
      width: 100px;
      margin-top: 20px;
    }
    .success-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 70vh;
    }
    .title {
      font-size: 16px;
      margin-bottom: 30px;
      font-weight: bold;
    }
    .text {
      font-size: 16px;
      margin-top: 10px;
      margin-bottom: 30px;
    }
    .extra-text {
      font-size: 16px;
      margin-top: 10px;
    }
    .redirect-button {
      margin-top: 60px;
      width: 350px;
    }
  `;

  return (
    <Grid css={styles}>
      <GridCell phone={4} tablet={8} desktop={12}>
        <Paper className="paper--content success-container">
          <Img src={zitelLogo} alt="zitel-logo" />
          <div className="success-wrapper">
            <div>
              <img src={Image} alt="zitel" style={{ width: "100%" }} />
              <Text className="title">پرداخت شما با موفقیت انجام شد.</Text>
              <Text className="text">تا لحظاتی دیگر بروزرسانی حساب کاربری شما انجام خواهد شد.</Text>
              {trackNumber && <Text className="extra-text"> شماره پیگیری: {trackNumber} </Text>}
              {bssReceiptNumber && <Text className="extra-text"> شماره رسید: {bssReceiptNumber} </Text>}
              <Button className="redirect-button" onClick={() => history.replace("/financial/receipts")}>
                سامانه مشترکین زی‌تل
              </Button>
            </div>
          </div>
        </Paper>
      </GridCell>
    </Grid>
  );
};

export default SucceedPayment;
